import { mapState } from 'vuex';

import { AuthLayout } from 'ipro-ui-kit-vuejs/src/layouts';

import { ContainerMixin } from '@/core/mixins';

// @vue/component
export default {
  components: {
    AuthLayout,
  },
  mixins: [
    ContainerMixin,
  ],
  computed: {
    ...mapState({
      iproLink: state => state.config.iproLink,
    }),
  },
};
